import { bhEnv } from '@lib/env'

export const handleError = (error: Error) => {
  if (bhEnv.nodeEnv === 'development') {
    console.error(error)
  }

  // TODO: user facing error message
}
